export const checkinModalConversation = {
  guestFallback: "Voyageur",
  conversationLabel: "Conversation :",
  replyOnWhatsAppLabel: "Répondre sur WhatsApp :",
  replyOnWhatsAppTooltip: "Répondre sur WhatsApp",
};
